import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AbcComponentModule } from './base/src/abcComponent.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, AbcComponentModule],
  exports: [AbcComponentModule],
})
export class AbcUiComponentsModule {}
